var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supervise-schedule"},[_c('h2',[_vm._v("课程表")]),_c('Schedule')],1)}
var staticRenderFns = []

export { render, staticRenderFns }